import { object } from '@gogame/schemas';

import { FILTERS, TABLE_SETTINGS } from 'scenes/Annotations/constants';

import { columnsSchema } from './columnsSchema';
import { filtersSchema } from './filtersSchema';
import { tableSettingsSchema } from './tableSettingsSchema';

export const presetSchema = object({
  [FILTERS]: filtersSchema,
  [TABLE_SETTINGS]: tableSettingsSchema,
  columns: columnsSchema,
});

export const mapStateToPreset = screenState =>
  presetSchema.stripDefaults().cast(screenState, {
    applyConst: true,
    stripUnknown: true,
  });
